<template>
  <div class="zyc-rotation-switch">
    <h1 v-html="title" @click="goList()" style="z-index: 5!important;"></h1>
    <div :id="id" class="zyc-rotation-switch-content">

      <div class="card" v-for="i in data">
        <div :class="'zyc-rotation-switch-item '+i.icon" @click="goList(i)">
          <h2>{{ i.title }}</h2>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import $ from "jquery"; //jquery 封装的旋转组件
import carousel from '../js/jquery.cloud9carousel' //jquery轮播盒子配置项

/**
 * 旋转切换
 */
export default {
  name: 'zycRotationSwitch',
  props: {
    data: {
      type: Array,
      default: []
    },
    title: {
      type: String,
      default: ''
    },
    pathName: {
      type: String,
      default: ''
    }
  },
  model: {},
  watch: {},
  data() {
    return {
      id: Math.random().toString(36).slice(2)
    }
  },
  mounted() {

  },
  created() {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    init: function () {
      var showcase = $("#" + this.id) //初始化命名 随机一个唯一的id填入
      //Cloud9Carousel---配置项
      showcase.Cloud9Carousel({
        yOrigin: 295, //盒子左上角位于父的y轴位置 --y定位
        yRadius: 160, //旋转元素y轴高度
        xOrigin: 570,
        xRadius: 720,
        farScale:0.5, //转到后面的盒子大小  比正常小有距离感
        transforms:true, //启用CsS转换  否则缩放不生效 都一样大没距离感
        autoPlay: true, //自动播放
        autoPlayDelay: 4000, //旋转等待时间
        speed: 4, //旋转过度速度  数越大 转速越快
        smooth: true, //启用平滑动画
        itemClass: "card", //收集所有这个类名的元素作为圈上的元素 均匀分布 旋转
        buttonLeft: $(".nav.left"),
        buttonRight: $(".nav.right"),
        bringToFront: true,
        onLoaded: function () {
          //.css 设置大盒子容器样式
          showcase.css('overflow', 'inherit')
          showcase.css('visibility', 'visible')
          showcase.css('display', 'none')
          showcase.fadeIn(1500) //进入页面 由透明变实体的过度所用时间
        },
        onRendered: function (a) {
          //find是jQuery中用于查找DOM元素的方法返回数组好像  each是遍历方法
          showcase.find('.zyc-rotation-switch-item').each((i, v) => {
            if (i == a.nearestIndex()) {
              $(v).addClass('zyc-rotation-switch-item-active')
            } else {
              $(v).removeClass('zyc-rotation-switch-item-active')
            }
          })
        }
      })
    },
    goList(item) {
      const val = item && typeof item === 'object' ? (item.code || item.title) : item
      this.$router.push({
        name: this.pathName,
        params: {title: val},
        query: {title: val}
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/zyc/other/rotationSwitch.vue